{
  "access": {
    "name": "Access",
    "description": "Access type to a process",
    "permutations": ["access", "access_mask", "granted_access"]
  },
  "accesses": {
    "name": "Accesses",
    "description": "",
    "permutations": ["access_reasons", "accesses"]
  },
  "account_id": {
    "name": "Account ID",
    "description": "An account ID number, such as the numeric ID number for a cloud account",
    "permutations": [
      "^AccountID",
      "acc_id",
      "account_id",
      "aws_account_id",
      "UserIdentityAccountId"
    ]
  },
  "account_name": {
    "name": "Account Name",
    "description": "An account name",
    "permutations": ["acc_name", "account_name"]
  },
  "action": {
    "name": "Action",
    "description": "Action taken or describes action success/deny/allowed etc",
    "permutations": ["action", "actions", "file_status", "result", "status"]
  },
  "alert_type": {
    "name": "Alert Type",
    "description": "The type of alert",
    "permutations": ["alert_type", "note"]
  },
  "application_name": {
    "name": "Application Name",
    "description": "Name of the process responsible for the action being performed, such as a network connection or a file write",
    "permutations": ["app_name", "application_name"]
  },
  "bytes_in": {
    "name": "Bytes In",
    "description": "How many bytes were received by the target service/host",
    "permutations": [
      "bytes_in",
      "bytes_inbound",
      "bytes_received",
      "bytes_recv",
      "destination_bytes",
      "resp_bytes",
      "respond_bytes",
      "response_bytes",
      "bytesTransferredOIn",
      "additionalEventData.bytesTransferredIn"
    ]
  },
  "bytes_out": {
    "name": "Bytes Out",
    "description": "How many bytes were sent by the target service/host",
    "permutations": [
      "bytes_out",
      "bytes_outbound",
      "bytes_sent",
      "orig_bytes",
      "original_bytes",
      "source_bytes",
      "additionalEventData.bytesTransferredOut",
      "bytesTransferredOut"
    ]
  },
  "cipher_suite": {
    "name": "Cipher Suite",
    "description": "",
    "permutations": [
      "cipher",
      "cipher_string",
      "cipher_suite",
      "cipher_text",
      "tls_cipher"
    ]
  },
  "client_issuer": {
    "name": "Client Issuer",
    "description": "Name of the issuing entity for the certificate, such as which CA issued the certificate",
    "permutations": ["client_issuer", "issuer", "tls_client_issuer"]
  },
  "client_subject": {
    "name": "Client Subject",
    "description": "Name of the entity to which the certificate was issued to",
    "permutations": ["client_subject", "subject", "tls_client_subject"]
  },
  "cloud_platform": {
    "name": "Cloud Platform",
    "description": "Cloud platform or provider (aws, gcp, azure, etc)",
    "permutations": [
      "cloud_plat",
      "cloud_platform",
      "cloud_provider",
      "platform",
      "provider"
    ]
  },
  "dest_domain": {
    "name": "Destination Domain",
    "description": "The destination domain name, such as the target DNS domain or the target machine in Windows telemetry",
    "permutations": ["dest_domain", "destination_domain", "domain"]
  },
  "dest_hostname": {
    "name": "Destination Hostname",
    "description": "The destination hostname",
    "permutations": [
      "dest_hostname",
      "dest_nt_host",
      "destination_host_name",
      "destination_hostname",
      "dst_host_name",
      "dst_hostname",
      "dst_nt_host",
      "requestParameters.Host"
    ]
  },
  "dest_ip": {
    "name": "Destination IP Address",
    "description": "The IP address of the destination",
    "permutations": [
      "^DestIP",
      "^DestinationIP",
      "^DstIP",
      "dest",
      "dest_address",
      "dest_ip",
      "dest_ip_address",
      "dest_network_address",
      "destination",
      "destination_address",
      "destination_ip",
      "destination_ip_address",
      "destination_network_address",
      "dst",
      "dst_address",
      "dst_ip",
      "dst_ip_address",
      "dst_network_address",
      "id_resp_h",
      "id_resp_host"
    ]
  },
  "dest_mac": {
    "name": "Destination MAC Address",
    "description": "The destination MAC address",
    "permutations": [
      "dest_mac",
      "dest_mac_address",
      "destination_mac",
      "destination_mac_address",
      "dst_mac",
      "dst_mac_address"
    ]
  },
  "dest_port": {
    "name": "Destination Port",
    "description": "The destination network port",
    "permutations": [
      "dest_port",
      "destination_port",
      "id_resp_p",
      "id_resp_port"
    ]
  },
  "details": {
    "name": "Details",
    "description": "Similar to Message, this field houses the event details or the value of a registry key modification",
    "permutations": ["details", "message", "event_data"]
  },
  "dns_answer": {
    "name": "DNS Answer",
    "description": "Resolved address from a DNS query",
    "permutations": [
      "^DNSResponse",
      "answer",
      "dns_answer",
      "dns_answers",
      "dns_response",
      "zeek_dns_answers"
    ]
  },
  "dns_query": {
    "name": "DNS Query",
    "description": "A domain to be resolved",
    "permutations": [
      "^DNSRequest",
      "dns_query",
      "dns_query_name",
      "dns_request",
      "query",
      "query_domain"
    ]
  },
  "dns_record_type": {
    "name": "DNS Record Type",
    "description": "A DNS record type (A, NS, MX, etc.)",
    "permutations": ["^zeek.dns.qtype_name", "dns_record_type", "record_type"]
  },
  "domain": {
    "name": "Domain",
    "description": "A domain name (foo.bar.com)",
    "permutations": [
      "^tls.client.server_name",
      "^zeek.ssl.server.name",
      "destination_domain",
      "domain",
      "domain_dst",
      "domain_name",
      "dst_domain",
      "host",
      "server_name",
      "ssl_server_name",
      "tls_server_name",
      "url_domain"
    ]
  },
  "email_recipient": {
    "name": "Email Recipient",
    "description": "The email address of the message recipient(s)",
    "permutations": [
      "email_recipient",
      "email_recipients",
      "recipient",
      "recipients",
      "smtp_to"
    ]
  },
  "email_sender": {
    "name": "Email Sender",
    "description": "The email address of the message sender",
    "permutations": ["email_sender", "sender", "smtp_from", "src_user"]
  },
  "email_subject": {
    "name": "Email Subject",
    "description": "The subject of an email message",
    "permutations": [
      "email_subject",
      "message_subject",
      "smtp_subject",
      "subject",
      "subject_line",
      "subject_text"
    ]
  },
  "event_id": {
    "name": "Event ID",
    "description": "Identifier for an event such as 4688 for Windows or 1 for Sysmon",
    "permutations": ["^EventID", "EventCode", "event_code", "event_id"]
  },
  "event_type": {
    "name": "Event Type",
    "description": "Classification of the event, such as process, registry or network",
    "permutations": [
      "event_type",
      "event_category",
      "eventCategory",
      "category"
    ]
  },
  "file_name": {
    "name": "File Name",
    "description": "Name of the targeted file with in a file write or load event",
    "permutations": ["file_full_name", "file_name", "FileName"]
  },
  "file_path": {
    "name": "File Path",
    "description": "Full tath to the targeted file in a file write, load or simialr event",
    "permutations": [
      "^TargetFileName",
      "^TargetFilename",
      "^event.FilePath",
      "endgame_file_path",
      "file_path",
      "filemod",
      "filemod_name",
      "filepath",
      "path"
    ]
  },
  "hostname": {
    "name": "Hostname",
    "description": "A device identification nickname",
    "permutations": [
      "^event.ComputerName",
      "agent_name",
      "computer_name",
      "computername",
      "device",
      "device_name",
      "endgame_computer_name",
      "host",
      "host_name",
      "hostname",
      "system_name"
    ]
  },
  "image": {
    "name": "Image",
    "description": "Full process path of a process execution event",
    "permutations": [
      "image",
      "proc_name",
      "process_name",
      "source_image",
      "src_image",
      "target_image"
    ]
  },
  "instance_id": {
    "name": "Instance ID",
    "description": "ID of the event source instance",
    "permutations": ["^InstanceID", "instance_id"]
  },
  "instance_name": {
    "name": "Instance Name",
    "description": "Name of the event source instance",
    "permutations": ["instance_name"]
  },
  "instance_type": {
    "name": "Instance Type",
    "description": "Type of the event source instance",
    "permutations": ["instance_type"]
  },
  "logon_process": {
    "name": "Logon Process",
    "description": "Process associated with a user logon event",
    "permutations": ["logon_process"]
  },
  "logon_type": {
    "name": "Logon Type",
    "description": "Logon Type code",
    "permutations": ["logon_type"]
  },
  "md5": {
    "name": "MD5 Hash",
    "description": "MD5 cryptographic hash",
    "permutations": [
      "^FileMD5",
      "^MD5",
      "^MD5Hash",
      "^MD5HashData",
      "^MD5String",
      "^MD5Sum",
      "^event.MD5String",
      "endgame_md5",
      "file_md5",
      "md5",
      "md5_file",
      "md5_hash",
      "md5_string",
      "md5_sum"
    ]
  },
  "message": {
    "name": "Message",
    "description": "Event Message containing details of the event, typically unparsed and complete details of the event",
    "permutations": ["description", "message", "message_body", "msg"]
  },
  "object_loaded": {
    "name": "Object Loaded",
    "description": "DLL or module loaded as part of a process execution",
    "permutations": [
      "file_path",
      "image_loaded",
      "modload",
      "modload_name",
      "object_loaded",
      "object_name",
      "object_path",
      "path"
    ]
  },
  "object_name": {
    "name": "Object Name",
    "description": "Describes the target object, such as registry key or filename created, modified or deleted in a Windows environment",
    "permutations": [
      "^winlog.event_data.ObjectName",
      "object_name",
      "ObjectName"
    ]
  },
  "parent_image": {
    "name": "Parent Image",
    "description": "Parent process of the executing process",
    "permutations": [
      "parent_image",
      "parent_proc_name",
      "parent_process_name",
      "source_image"
    ]
  },
  "parent_process_cmdline": {
    "name": "Parent Process Command Line",
    "description": "Path of the parent process and its command line arguments",
    "permutations": [
      "^event.ParentCommandLine",
      "^process.parent.command_line",
      "parent_command_line",
      "parent_proc_cmdline",
      "parent_process_cmdline",
      "proc_parent_cmdline",
      "process_parent_cmdline"
    ]
  },
  "parent_process_id": {
    "name": "Parent Process Identifier",
    "description": "Number used to uniquely identify the parent process",
    "permutations": [
      "^Creator_Process_ID",
      "creator_process_id",
      "parent_process_id"
    ]
  },
  "parent_process_name": {
    "name": "Parent Process Name",
    "description": "Name of the parent process. Utilize path as it contains the name, except where logic does not allow",
    "permutations": [
      "^event.ParentImageFileName",
      "parent_name",
      "parent_proc_name",
      "parent_process_name",
      "process_parent_path"
    ]
  },
  "parent_process_path": {
    "name": "Parent Process Path",
    "description": "File system path to the parent process",
    "permutations": [
      "^endgame.parent_process_path",
      "^event.ParentImageFileName",
      "creator_process_name",
      "parent_image",
      "parent_name",
      "parent_path",
      "parent_proc_path",
      "parent_process_path",
      "process_parent_path",
      "source_image"
    ]
  },
  "pipe_name": {
    "name": "Pipe Name",
    "description": "Named pipe string",
    "permutations": ["pipe_name"]
  },
  "process_cmdline": {
    "name": "Process Command Line",
    "description": "The full process command-line string",
    "permutations": [
      "^event.CommandLine",
      "^winlog.event_data.ScriptBlockText",
      "child_command_line",
      "cmdline",
      "command",
      "command_line",
      "endgame_command_line",
      "proc_cmdline",
      "proc_command_line",
      "process_cmd",
      "process_cmdline",
      "process_command_line",
      "cliCommand"
    ]
  },
  "process_id": {
    "name": "Process Identifier",
    "description": "Number used to uniquely identify an active process",
    "permutations": [
      "^event.ProcessId",
      "p_id",
      "pid",
      "proc_id",
      "process_id",
      "process_identifier"
    ]
  },
  "process_name": {
    "name": "Process Name",
    "description": "Name of the process",
    "permutations": ["childproc_name", "proc_name", "process_name"]
  },
  "process_path": {
    "name": "Process Path",
    "description": "Full path to the process",
    "permutations": [
      "^event.FilePath",
      "^winlog.event_data.ProcessName",
      "endgame_process_path",
      "new_process_name",
      "path",
      "proc_path",
      "process_executable",
      "process_image_path",
      "process_path",
      "target_image"
    ]
  },
  "protocol": {
    "name": "Network Protocol",
    "description": "The OSI layer 3 (network) protocol",
    "permutations": ["network_protocol", "proto", "protocol", "transport"]
  },
  "record_id": {
    "name": "Record ID",
    "description": "Unique record ID or record UUID",
    "permutations": ["^RecordID", "record_id", "record_number"]
  },
  "referrer": {
    "name": "HTTP Referrer",
    "description": "The HTTP referrer used in the request",
    "permutations": [
      "cs_referer",
      "cs_referrer",
      "http_referer",
      "http_referrer",
      "http_request_referrer",
      "referer",
      "referrer"
    ]
  },
  "region": {
    "name": "Region",
    "description": "A location region",
    "permutations": ["region", "awsRegion"]
  },
  "registry_hive": {
    "name": "Registry Hive",
    "description": "The registry hive such as HKLM",
    "permutations": [
      "hive",
      "hive_name",
      "reg_hive",
      "reg_hive_name",
      "registry_hive",
      "registry_hive_name"
    ]
  },
  "registry_key_name": {
    "name": "Registry Key Name",
    "description": "Name of the registry key",
    "permutations": [
      "^winlog.event_data.ObjectName",
      "object_name",
      "reg_key",
      "reg_key_name",
      "reg_key_str",
      "reg_key_string",
      "registry_key",
      "registry_key_name",
      "registry_key_string",
      "regmod",
      "regmod_name"
    ]
  },
  "registry_new_value_name": {
    "name": "Registry New Value Name",
    "description": "New registry value created associated with the registry key, such as 0 as a DWORD",
    "permutations": [
      "^winlog.event_data.NewValue",
      "new_value",
      "reg_new_value",
      "registry_new_value_name"
    ]
  },
  "registry_old_value_name": {
    "name": "Registry Old Value Name",
    "description": "Previous registry value overwritten by the new value associated with a registry key, such as 0 as a DWORD",
    "permutations": [
      "^winlog.event_data.OldValue",
      "old_value",
      "reg_old_value",
      "registry_old_value",
      "registry_old_value_name"
    ]
  },
  "registry_path": {
    "name": "Registry Path",
    "description": "Full path of a Windows registry key, including the key name but excluding the value",
    "permutations": [
      "^winlog.event_data.TargetObject",
      "object_name",
      "registry_path",
      "regmod",
      "regmod_name",
      "target_object"
    ]
  },
  "registry_value_name": {
    "name": "Registry Value Name",
    "description": "Same as registry_new_value_name, where it is a new value modified, written or deleted from a registry key name, such as DWORD 0",
    "permutations": [
      "^winlog.event_data.ObjectValueName",
      "object_value_name",
      "registry_value",
      "registry_value_name"
    ]
  },
  "post_body": {
    "name": "HTTP POST Body",
    "description": "The body of a HTTP POST that was not supplied as parameters",
    "permutations": ["post_body"]
  },
  "request_method": {
    "name": "Request Method",
    "description": "The HTTP method used in the request (GET, PUT, POST, HEAD, etc)",
    "permutations": [
      "cs_method",
      "http_method",
      "http_request_method",
      "method",
      "network_method",
      "request_method"
    ]
  },
  "service_file_path": {
    "name": "Service File Path",
    "description": "The file path of a service",
    "permutations": [
      "service_file_name",
      "service_file_path",
      "svc_file_name",
      "svc_file_path"
    ]
  },
  "service_name": {
    "name": "Service Name",
    "description": "The name of a service",
    "permutations": ["service_name", "svc_name"]
  },
  "severity": {
    "name": "Severity",
    "description": "The severity of an alert or threat",
    "permutations": ["alert_severity", "severity"]
  },
  "sha256": {
    "name": "SHA256 Hash",
    "description": "SHA-256 cryptographic hash",
    "permutations": [
      "^FileSHA256",
      "^SHA256",
      "^SHA256Hash",
      "^SHA256HashData",
      "^SHA256String",
      "^SHA256Sum",
      "^event.SHA256String",
      "endgame_sha256",
      "file_sha256",
      "sha256",
      "sha256_file",
      "sha256_hash",
      "sha256_string",
      "sha256_sum"
    ]
  },
  "sid": {
    "name": "Security Identifier (SID)",
    "description": "A Windows SID",
    "permutations": [
      "^SecurityID",
      "^Security_ID",
      "security_id",
      "security_identifier",
      "sid"
    ]
  },
  "src_hostname": {
    "name": "Source Hostname",
    "description": "The source hostname",
    "permutations": [
      "source_host_name",
      "source_hostname",
      "source_nt_host",
      "src_host_name",
      "src_hostname",
      "src_nt_host"
    ]
  },
  "src_ip": {
    "name": "Source IP Address",
    "description": "The IP address of the source",
    "permutations": [
      "^SourceIP",
      "^SrcIP",
      "id_orig_h",
      "id_orig_host",
      "source",
      "source_address",
      "source_ip",
      "source_ip_address",
      "source_network_address",
      "src",
      "src_address",
      "src_ip",
      "src_ip_address",
      "src_network_address",
      "sourceIPAddress"
    ]
  },
  "src_mac": {
    "name": "Source MAC Address",
    "description": "The source MAC address",
    "permutations": [
      "source_mac",
      "source_mac_address",
      "src_mac",
      "src_mac_address"
    ]
  },
  "src_port": {
    "name": "Source Port",
    "description": "The source network port",
    "permutations": ["id_orig_p", "id_orig_port", "source_port", "src_port"]
  },
  "status_code": {
    "name": "Status Code",
    "description": "The HTTP response status code (200, 404, 503, etc)",
    "permutations": [
      "^http.response.status_code",
      "request_status",
      "status",
      "status_code"
    ]
  },
  "target_path": {
    "name": "Target Path",
    "description": "",
    "permutations": [
      "^winlog.event_data.TargetImage",
      "filemod",
      "filemod_name",
      "target_file_name",
      "target_filename",
      "target_image",
      "target_path"
    ]
  },
  "task_category": {
    "name": "Task Category",
    "description": "",
    "permutations": [
      "category",
      "object_category",
      "task_category",
      "winlog_task"
    ]
  },
  "title": {
    "name": "Title",
    "description": "A title of a log or alert",
    "permutations": ["alert_subject", "alert_title", "subject", "title"]
  },
  "uri": {
    "name": "Uniform Resource Identifier (URI)",
    "description": "The path of the resource served by the webserver or proxy, '/index.html' for example",
    "permutations": [
      "cs_uri_path",
      "http_request_uri",
      "http_uri",
      "uniform_request_identifer",
      "uri",
      "uri_path"
    ]
  },
  "url": {
    "name": "Uniform Resource Locator (URL)",
    "description": "The full web address, including the domain, uri and uri parameters",
    "permutations": ["http_url", "network_url", "url", "url_full"]
  },
  "user_agent": {
    "name": "User Agent String",
    "description": "The user agent used in the request",
    "permutations": [
      "^cs_User_Agent",
      "^user_agent.original",
      "cs_user_agent",
      "cs_useragent",
      "http_user_agent",
      "user_agent",
      "user_agent_name",
      "user_agent_string",
      "userAgent"
    ]
  },
  "username": {
    "name": "Username",
    "description": "An identification used by a person with access to a computer, network, or online service",
    "permutations": [
      "^event.UserName",
      "user",
      "user_name",
      "username",
      "userName",
      "userIdentity.userName"
    ]
  },
  "identity_principal_id": {
    "name": "User Identity Principal ID",
    "description": "The AWS internal ID of the entity used to get credentials",
    "permutations": ["userIdentity.principalId"]
  },
  "group_id": {
    "name": "User Group ID",
    "description": "Provides a conceptual overview of AWS Identity and Access Management (IAM) identities",
    "permutations": ["user_group_id"]
  },
  "user_type": {
    "name": "User Type",
    "description": "The role type within AWS identity management",
    "permutations": ["user_type", "userIdentity.type"]
  },
  "event_name": {
    "name": "Event Name",
    "description": "The name of an event, verus utilizing the ID",
    "permutations": ["event_name"]
  },
  "authentication_method": {
    "name": "User Authentication Method",
    "description": "Normalized name of the type of authentication performed by a user to a service/API/device",
    "permutations": [
      "authentication_method",
      "auth_method",
      "user_method",
      "authenticationMethod"
    ]
  },
  "error_code": {
    "name": "Event Error Code",
    "description": "The ID or short name for an Error Message Event",
    "permutations": ["errorCode", "ErrorCode"]
  },
  "error_message": {
    "name": "Event Error Details",
    "description": "The full message for an Error Message Event",
    "permutations": ["errorMessage", "ErrorMessage", "result"]
  },
  "storage_property_name": {
    "name": "Target Storage Entity Name",
    "description": "Target Storage Identity Name, such as AWS Bucket Name",
    "permutations": ["requestParameters.bucketName", "bucketName", "BucketName"]
  },
  "storage_target_object": {
    "name": "Target Storage Object  Name",
    "description": "Target Storage Identity Object being requested, such as a file in an AWS Bucket",
    "permutations": [
      "requestParameters.key",
      "Key",
      "bucketFileName",
      "bucketKey",
      "RequestKey"
    ]
  },
  "user_access_id": {
    "name": "User Access Key ID",
    "description": "ID of the Access Key utilized by a user/service to access an object via API",
    "permutations": [
      "userIdentity.accessKeyId",
      "UserIdentityAccessKeyId",
      "AccessKeyId",
      "userIdentityAccessKeyId"
    ]
  },
  "source_user_role": {
    "name": "Originating User Role",
    "description": "Source/Originating User Role such as AWS ARN ID or name",
    "permutations": ["requestParameters.roleArn", "user_role", "roleArn"]
  },
  "user_role": {
    "name": "Target User Role",
    "description": "Target User Role such as AWS ARN ID or name",
    "permutations": ["UserIdentityArn", "userIdentity.arn", "user_arn"]
  },
  "mfa_auth": {
    "name": "MFA Authentication Status",
    "description": "Boolean value to determine if MFA was utilized for the user authentication",
    "permutations": [
      "SessionMfaAuthenticated",
      "userIdentity.sessionContext.attributes.mfaAuthenticated",
      "mfaAuthentication"
    ]
  },
  "request_parameters": {
    "name": "Cloud API Request Parameters",
    "description": "Field containing all of the request parameter data associated with a Cloud API request",
    "permutations": ["requestParameters"]
  },
  "service": {
    "name": "Application Service Name",
    "description": "Name of a service or protocol identified in network or host loggin",
    "permutations": [
      "service",
      "service_name",
      "application_name",
      "application_service"
    ]
  },
  "name": {
    "name": "Event Name",
    "description": "Name of an event ID or type as it relates to network activity",
    "permutations": ["event_name", "eventName", "Name", "name"]
  }
}
